/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from "react";

import { Collapse, IconButton, Stack, Tooltip } from "@mui/material";
import { Globe02Icon } from "components/Icon";
import { i18n } from "translations";
import { rem, capitalize } from "utils";

import TextFieldHookForm from "./TextField.hookform";
import { TextFieldProps } from "./TextField.types";

interface TextFieldMultiLanProps {
  name: any;
  label: string;
  required?: boolean;
  textFieldProps: TextFieldProps;
}

const TextFieldMultiLan: React.FC<TextFieldMultiLanProps> = ({
  name,
  label,
  required,
  textFieldProps,
}) => {
  const convertNativeName = useCallback((param: string) => {
    if (param?.includes(".")) {
      const parts = param.split(".");

      const lastPart = parts.pop() || "";

      const capitalizedLastPart =
        lastPart.charAt(0).toUpperCase() + lastPart.slice(1);

      const newLastPart = `native${capitalizedLastPart}`;

      parts.push(newLastPart);

      return parts.join(".");

      // Join the parts back together
    }
    return `native${capitalize(param)}`;
  }, []);

  const [open, setOpen] = useState(false);
  return (
    <Stack
      sx={{
        "& .MuiBox-root[placement='after']": {
          padding: "0px !important",
          height: "inherit",
        },
      }}
    >
      <TextFieldHookForm
        name={convertNativeName(name as string)}
        label={label}
        addonAfter={
          <Tooltip arrow title={i18n.t("showAlternativeLanguage")}>
            <IconButton
              onClick={() => setOpen((active) => !active)}
              sx={{ height: rem(30) }}
            >
              <Globe02Icon fontSize="small" />
            </IconButton>
          </Tooltip>
        }
        required={required}
        {...textFieldProps}
      />
      <Collapse in={open} sx={{ paddingTop: open ? rem(12) : 0 }}>
        <TextFieldHookForm
          name={name}
          label={`${label} (${i18n.t("alternativeLanguage")})`}
          {...textFieldProps}
        />
      </Collapse>
    </Stack>
  );
};

export default TextFieldMultiLan;
